import React from 'react';
import './EnergyDisplay.css';

interface EnergyDisplayProps {
  energy: number;
  className?: string;
}

const EnergyDisplay: React.FC<EnergyDisplayProps> = ({ energy, className = '' }) => {
  return (
    <div className={`energy-display ${className}`}>
      <div className="energy-icon">
        <img 
          src="/images/checkin/energy.png" 
          alt="Energy" 
          className="energy-image"
        />
      </div>
      <span className="energy-value">{energy.toLocaleString()}</span>
    </div>
  );
};

export default EnergyDisplay;
